'use strict';

export default class ParagraphTypeAccordion {
  constructor() {
    var $counter = 0;

    $('.accordion_trigger_content').prepend('<div class="item_trigger_wrapper"></div>');

    // $('.paragraph--type--accordion-item').each(function () {
    //   $(this).find('.item_trigger').data('id', $counter).addClass('item_trigger_' + $counter);
    //   $(this).find('.item_trigger_content').data('id', $counter).addClass('item_trigger_content_' + $counter);
    //   $(this).closest('.accordion_trigger_content').find('.item_trigger_wrapper').append($(this).find('.item_trigger'));
    //   $counter++;
    // })

    // $('.item_trigger').on('click mouseover', function ($event) {
    //   $event.preventDefault();
    //   var $content_to_show = ".item_trigger_content_" + $(this).data('id');
    //   $(this).closest('.accordion_trigger_content').find('.active').removeClass('active');
    //   $($content_to_show).addClass('active');
    //   $(this).addClass('active');
    // })

    $('.accordion_trigger').click(function ($event) {
      $event.preventDefault();
      $(this).siblings('.accordion_trigger_content').slideToggle();
      $(this).toggleClass('active');
      // $(this).siblings('.accordion_trigger_content').find('.item_trigger').first().click();
    })

    // $('.accordion_trigger_content').each(function () {
    //   $(this).find('.item_trigger').first().click();
    // });
  
    
    $('.paragraph--type--accordion .paragraph--type--accordion-item').click(function ($event) {
      $event.preventDefault();
      $(this).find('.item_trigger_content').slideToggle();
      $(this).toggleClass('active');
    })

  }
}
